import React from "react";
import { connect } from "react-redux";
import Select from "react-select";
import moment from "moment";
import TitleComponent from "../../components/TitleComponent";
import BaseForm from "../../components/TaskForms/BaseForm";
import Inne from "../../components/TaskForms/Inne";
import DyzurTelefoniczny from "../../components/TaskForms/DyzurTelefoniczny";
import SpotkanieInformacyjne from "../../components/TaskForms/SpotkanieInformacyjne";
import WizytaHotelowa from "../../components/TaskForms/WizytaHotelowa";
import WycieczkaFakultatywna from "../../components/TaskForms/WycieczkaFakultatywna";
import Transfer from "../../components/TaskForms/Transfer";
import WylotyPrzyloty from "../../components/TaskForms/WylotyPrzyloty";
import ModalInfo from "../../containers/ModalInfo";
import produce from "immer";
import api from "../../api";
import { notify } from "react-notify-toast";
import { getObjectValue, capitalize, handleApiError } from "../../lib/helper";
import isEmpty from "lodash.isempty";
import config from "../../config";
import Loader from "../../components/LoaderComponent";
import withTranslation from "../../i18n/withTranslation";
import { formatDate, formatWeekday } from "../../i18n/dates";
import { TASK_TYPES, TASK_TYPE_LABEL_KEYS } from "../../consts/taskTypes";

const uuid = require("uuid/v4");
const dateFormat = config.get("dateFormat");

class New extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         selectedTask: null,
         forms: [],
         // Backend enums ONLY. Storing a translated label here would freeze it at mount and the
         // task-type dropdown would keep the old language after a switch (BRR-871).
         // Labels are derived per render in taskOptions().
         options: [
            TASK_TYPES.DYZUR_TELEFONICZNY,
            TASK_TYPES.SPOTKANIE_INFORMACYJNE,
            TASK_TYPES.WIZYTA_HOTELOWA,
            TASK_TYPES.WYCIECZKA_FAKULTATYWNA,
            TASK_TYPES.BIURO,
            TASK_TYPES.DAY_OFF,
            TASK_TYPES.INNE
         ],
         optionalTrips: this.parseOptionalTrips(),
         users: this.parseUsers(props),
         scrolled: false,
         modalVisibility: false,
         deletedTaskId: null,
         hotels: [],
         dataFetching: true,
         transferList: {},
         newTaskDate: null,
         newTaskId: null,
         warningMessage: null,
         hotelsVisit: null
      };
   }

   componentDidMount = () => {
      this.fetchTasksData();
   };

   componentDidUpdate = () => {
      const { scrolled } = this.state;
      if (!scrolled) this.scrollToForm();
   };

   fetchTasksData = () => {
      const { location } = this.props;
      const { options } = this.state;
      const { user, selectedProductKey, day } = location.state;
      const date = moment(day).format(dateFormat);
      const promiseArray = [];
      let forms,
         hotels,
         hotelsVisit,
         transferList = [],
         flightList = [],
         arrivalList = [];
      promiseArray.push(
         api.getTasks({ userId: user.id, date, productKey: selectedProductKey }).then((data) => (forms = data.data))
      );
      promiseArray.push(
         api
            .getTaskInit(selectedProductKey, date, "SpotkanieInformacyjne")
            .then((data) => (hotels = this.parseHotels(data.data.hotele)))
      );
      promiseArray.push(
         api
            .getTaskInit(selectedProductKey, date, "Transfer")
            .then((data) => (transferList = data.data))
      );
      promiseArray.push(
         api
            .getTaskInit(selectedProductKey, date, "WizytaHotelowa")
            .then((data) => (hotelsVisit = this.parseHotels(data.data.hotele)))
      );
      promiseArray.push(
         api
            .getTaskInit(selectedProductKey, date, "Przylot")
            .then((data) => (arrivalList = data.data))
      );
      promiseArray.push(
         api.getTaskInit(selectedProductKey, date, "Wylot").then((data) => (flightList = data.data))
      );
      Promise.all(promiseArray).then(() => {
         const additionalOptions = produce(options, (draft) => {
            if (!isEmpty(transferList)) draft.push(TASK_TYPES.TRANSFER);
            if (!isEmpty(flightList)) draft.push(TASK_TYPES.WYLOT);
            if (!isEmpty(arrivalList)) draft.push(TASK_TYPES.PRZYLOT);
         });
         this.setState({
            forms,
            hotels,
            hotelsVisit,
            transferList,
            arrivalList,
            flightList,
            options: additionalOptions,
            dataFetching: false
         });
      });
   };

   parseOptionalTrips = () => {
      const { location, optionalTrips } = this.props;
      const date = moment(location.state.day).format("YYYY-MM-DD");
      return optionalTrips
         .filter((trip) => trip.data === date)
         .map((trip) => ({ value: trip.id, label: trip.nazwaWycieczki }));
   };

   parseHotels = (data = []) => {
      return data.map((hotel) => ({ value: hotel.id, label: hotel.nazwa, miejsceSpotkania: hotel.miejsceSpotkania }));
   };

   parseUsers = (props) => {
      const { location } = props;
      return location.state.users.map((user) => ({
         value: user.id,
         id: user.id,
         label: user.imieNazwisko,
         imieNazwisko: user.imieNazwisko
      }));
   };

   // Derives {value,label} pairs at RENDER time from the stored enums, so the dropdown follows
   // the language switch. Same approach as components/ReportModal.js.
   taskOptions = () =>
      this.state.options.map((typ) => ({
         value: typ,
         // Falls back to the raw enum if a task type is ever added without a label key - t()
         // tolerates a missing key but not an undefined one.
         label: TASK_TYPE_LABEL_KEYS[typ] ? this.props.t(TASK_TYPE_LABEL_KEYS[typ]) : typ
      }));

   selectView = (form) => {
      const { users, optionalTrips, hotels, transferList, flightList, arrivalList, hotelsVisit } =
         this.state;
      const options = this.taskOptions();
      if (form.method === "DELETE") return;
      switch (form.typ) {
         case "Inne":
            return (
               <Inne
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  hotels={hotels}
               />
            );
         case "DyzurTelefoniczny":
            return (
               <DyzurTelefoniczny
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  hotels={hotels}
               />
            );
         case "SpotkanieInformacyjne":
            return (
               <SpotkanieInformacyjne
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  hotels={hotels}
               />
            );
         case "WizytaHotelowa":
            return (
               <WizytaHotelowa
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  hotels={hotelsVisit}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
               />
            );
         case "WycieczkaFakultatywna":
            return (
               <WycieczkaFakultatywna
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  allTrips={optionalTrips}
                  key={form.id}
               />
            );
         case "Transfer":
            return (
               <Transfer
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  transferList={transferList}
               />
            );
         case "Wylot":
            return (
               <WylotyPrzyloty
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  initData={flightList}
               />
            );
         case "Przylot":
            return (
               <WylotyPrzyloty
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
                  initData={arrivalList}
               />
            );
         default:
            return (
               <BaseForm
                  handleChange={this.handleChange}
                  handleDestroy={this.showModal}
                  data={form}
                  allTasks={options}
                  allUsers={users}
                  key={form.id}
               />
            );
      }
   };

   scrollToForm = () => {
      const { location } = this.props;
      const { scrollToId } = location.state;
      if (!scrollToId) return this.setState({ scrolled: true });
      const form = document.getElementById(`form-${scrollToId}`);
      if (form) {
         window.scroll(0, form.offsetTop);
         this.setState({ scrolled: true });
      }
   };

   handleChange = (formData, typeChange = false) => {
      const forms = produce(this.state.forms, (draft) => {
         const index = draft.findIndex((form) => form.id === formData.id);
         draft[index] = Object.assign({}, formData);
         if (typeChange) {
            draft[index].dane = this.additionalFields(formData.typ);
         }
         if (formData.method !== "POST") {
            draft[index].method = "PUT";
         }
      });
      this.setState({ forms });
   };

   handleDestroy = () => {
      const { deletedTaskId, forms } = this.state;
      const changedForms = produce(forms, (draft) => {
         const index = draft.findIndex((form) => form.id === deletedTaskId);
         if (draft[index].method === "POST") {
            draft.splice(index, 1);
         } else {
            draft[index] = { id: deletedTaskId, method: "DELETE" };
         }
      });
      this.setState({ forms: changedForms, modalVisibility: false });
   };

   additionalFields = (type) => {
      switch (type) {
         case "Inne":
            return { godzina: "", hotele: [], miejsce: "", uwagi: "" };
         case "DyzurTelefoniczny":
            return { godzina: "", hotele: [], miejsce: "", uwagi: "" };
         case "SpotkanieInformacyjne":
            return { godzina: "", hotele: [], miejsce: "", uwagi: "" };
         case "WizytaHotelowa":
            return { hotele: [], miejsce: "", godzOd: "", godzDo: "", uwagi: "" };
         case "Wylot":
         case "Przylot":
            return { trasaWCId: null, nazwaTrasy: "", dataTrasyWC: "" };
         case "Transfer":
            return {
               dataTrasyWC: "",
               dataWylotu: "",
               trasaWCId: null,
               nazwaTrasy: "",
               uwagi: "",
               transferyKlientow: {
                  data: "",
                  godzinaOd: "",
                  transferHotele: []
               }
            };
         case "WycieczkaFakultatywna":
            return { id: "" };
         case "DayOff":
            return { dayOff: "true" };
         default:
            return { uwagi: "" };
      }
   };

   closeModal = () => {
      this.setState({ modalVisibility: false, deletedTaskId: null });
   };

   showModal = (id) => {
      this.setState({ modalVisibility: true, deletedTaskId: id });
   };

   handleSelect = (selectedTask) => {
      let { forms } = this.state;
      const { location } = this.props;
      const date = moment(location.state.day);
      const mainUser = location.state.user;
      const form = {
         method: "POST",
         id: uuid(),
         typ: selectedTask.value,
         dane: this.additionalFields(selectedTask.value),
         data: moment(date).format("YYYY-MM-DD"),
         kodProduktu: location.state.selectedProductKey,
         uzytkownicy: [
            { id: mainUser.id, imieNazwisko: mainUser.imieNazwisko, label: mainUser.imieNazwisko }
         ]
      };
      this.setState({ forms: forms.concat(form), newTaskDate: date, newTaskId: form.id });
   };

   validateForms = (notValidHotelList) => {
      const { forms } = this.state;
      let requirementsMet = true;
      const requiredFields = {
         Inne: ["uzytkownicy", "dane.nazwa"],
         DyzurTelefoniczny: ["uzytkownicy"],
         SpotkanieInformacyjne: ["uzytkownicy", "dane.godzina", "dane.hotele", "dane.miejsce"],
         WizytaHotelowa: [
            "uzytkownicy",
            "dane.godzDo",
            "dane.godzOd",
            "dane.hotele",
            "dane.miejsce"
         ],
         WycieczkaFakultatywna: ["uzytkownicy", "dane.id"],
         DayOff: ["uzytkownicy", "dane.dayOff"],
         Transfer: ["uzytkownicy", "dane.trasaWCId", "dane.transferyKlientow.transferHotele"],
         Biuro: ["uzytkownicy"],
         Wylot: ["uzytkownicy", "dane.trasaWCId", "dane.nazwaTrasy", "dane.dataTrasyWC"],
         Przylot: ["uzytkownicy", "dane.trasaWCId", "dane.nazwaTrasy", "dane.dataTrasyWC"]
      };
      forms.forEach((form) => {
         if (form.method === "DELETE") return;
         const required = requiredFields[form.typ];
         required.forEach((element) => {
            let value = getObjectValue(form, element);
            if (typeof value === "number") value = value.toString();
            if (isEmpty(value)) {
               requirementsMet = false;
               value && value.hotel && notValidHotelList.push(value.hotel.nazwa);
            }
            if (Array.isArray(value))
               value.forEach((val) => {
                  if (val.godzinaZbiorki !== undefined && val.miejsceZbiorki !== undefined) {
                     if (isEmpty(val.godzinaZbiorki) || isEmpty(val.miejsceZbiorki)) {
                        requirementsMet = false;
                        notValidHotelList.push(val.hotel.nazwa);
                     }
                  }
               });
         });
      });
      return requirementsMet;
   };

   saveChanges = () => {
      const { forms } = this.state;
      const notValidHotelList = [];
      if (!this.validateForms(notValidHotelList)) {
         return notify.show(
            this.props.t(
               notValidHotelList.length === 1
                  ? "tasks.validation.missingDataOneHotel"
                  : "tasks.validation.missingDataManyHotels",
               { hotels: notValidHotelList.join(", ") }
            ),
            "warning",
            5000
         );
      }
      this.setState({ dataFetching: true });
      const promiseArray = [];
      let promise;
      forms.forEach((task) => {
         switch (task.method) {
            case "POST": {
               const newTask = produce(task, (draft) => {
                  delete draft.id;
               });
               promise = api
                  .createTask(newTask)
                  .then((resp) => resp)
                  .catch(handleApiError, 'Task creation error');
               promiseArray.push(promise);
               break;
            }
            case "PUT":
               promise = api
                  .editTask(task.id, task)
                  .then((resp) => resp)
                  .catch(handleApiError, 'Task update error');
               promiseArray.push(promise);
               break;
            case "DELETE":
               promise = api
                  .deleteTask(task.id)
                  .then((resp) => resp)
                  .catch(handleApiError, 'Task delete error');
               promiseArray.push(promise);
               break;
            default:
               return;
         }
      });
      Promise.all(promiseArray).then(() => {
         this.setState({ dataFetching: false });
         const { location } = this.props;
         this.props.history.push({
            pathname: "/tasks-scheduler",
            state: {
               newTaskDay: location.state.day,
               scrollToId: this.state.newTaskId,
               prevPath: this.props.history.location.pathname
            }
         });
      });
   };

   renderModal = () => (
      <div>
         <p className="info_message margin--bottom">{this.props.t("tasks.confirmDelete")}</p>
         <div className="text-right">
            <button className="btn info__btn" onClick={() => this.handleDestroy()}>
               {this.props.t("common.actions.yes")}
            </button>
            <button className="btn info__btn" onClick={() => this.closeModal()}>
               {this.props.t("common.actions.no")}
            </button>
         </div>
      </div>
   );

   render() {
      const { selectedTask, forms, modalVisibility, dataFetching } = this.state;
      const options = this.taskOptions();
      const { location, t, locale } = this.props;
      const day = location.state.day;
      return (
         <div className="hotels__slide">
            <ModalInfo show={modalVisibility} onHide={this.closeModal}>
               {this.renderModal()}
            </ModalInfo>
            <TitleComponent>
               {location.state.user.imieNazwisko} - {formatDate(day)} (
               {capitalize(formatWeekday(day, locale))})
            </TitleComponent>
            <Loader show={dataFetching} />
            <div className="container_desktop">
               <div style={{ paddingTop: 30, paddingLeft: 15, paddingRight: 15 }}>
                  {forms.map((form) => this.selectView(form))}
                  <Select
                     value={selectedTask}
                     options={options}
                     placeholder={t("tasks.addTask")}
                     onChange={this.handleSelect}
                     menuPlacement="auto"
                  />
               </div>
               <div
                  style={{ marginTop: "25px" }}
                  className="center margin--bottom button_container flex flex--space-around"
               >
                  <button
                     disabled={dataFetching}
                     className="btn button__secondary button__rounded"
                     onClick={this.saveChanges}
                  >
                     {t("common.actions.saveChanges")}
                  </button>
               </div>
            </div>
         </div>
      );
   }
}

// withTranslation must stay OUTSIDE connect - see TasksScheduler.js for the reason.
export default withTranslation(
   connect((state) => ({
      optionalTrips: state.schedule.data.fakultety
   }))(New)
);
